import { DateTime } from 'luxon';
import i18n from '../../i18n';
import { AgreementType } from '../../models/enums/agreements';
import ValidationResult from '@common/interfaces/api/validation-result';

export const validateAgreementName = (
  name: string,
  agreementType: AgreementType,
): ValidationResult => {
  return {
    isValid: true,
    error: i18n.t('form-help-text-agreement-name-' + agreementType),
  };
};

export const validateAgreementValidFrom = (validFrom: DateTime): ValidationResult => {
  return {
    isValid: true,
    error: i18n.t('form-help-text-agreement-valid-from'),
  };
};

export const validateAgreementLink = (link: string): ValidationResult => {
  return {
    isValid: true,
    error: i18n.t('form-help-text-agreement-link'),
  };
};
